import Flex from './layouts/Flex';
import Box from './layouts/Box';
import Close from 'imagesUwKluis/svg/close.svg';
import {FC} from "react";

interface Props {
  value: boolean;
}

const PasswordCheckBox: FC<Props> = ({ value, children }) => (
  <Flex alignItems="center">
    <Flex
      bg={value ? 'succes' : 'alert'}
      justifyContent="center"
      borderRadius="50%"
      border="1px solid gray"
      width="16px"
      borderColor={value ? 'succes' : 'alert'}
      height="16px"
    >
      {value ? (
        <Box
          display="inline-block"
          height="10px"
          width="5px"
          borderBottom="1px solid white"
          borderRight="1px solid white"
          css={{
            transform: 'translate(1px, 1px) rotate(45deg)'
          }}
        />
      ) : (
        <Close fill="white" />
      )}
    </Flex>
    <Box ml="s">{children}</Box>
  </Flex>
);

export default PasswordCheckBox;
